import req from './../../../../fetch';
import { undocumentedResponse } from './../../../../utils';
import {
  ClaimType,
  NetworkType,
  AllAPIResponses,
  CarbonError,
} from './../../../../index';

type Params = {
  id: number;
  networkType: NetworkType;
};
type Payload = {
  functionName?: string;
  functionVersion?: string;
  uniqueId?: string;
};
const put = async (
  params: Params,
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<ClaimType>> => {
  const resp = await req.put(
    `/api/claims/${params.networkType}/${params.id}`,
    JSON.stringify(payload),
    headers
  );

  try {
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as ClaimType,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};
export default put;
